export const TASK_PANEL_LOADING_SET = 'at/panels/task/edit/TASK_PANEL_LOADING_SET'
export const TASK_PANEL_LOADED_SET = 'at/panels/task/edit/TASK_PANEL_LOADED_SET'
export const TASK_INFO_SET = 'at/panels/task/edit/TASK_INFO_SET'
export const OPEN_TASK_SET = 'at/panels/task/edit/OPEN_TASK_SET'
export const TASK_PANEL_ERRORS_ADD = 'at/panels/task/edit/TASK_PANEL_ERRORS_ADD'
export const TASK_PANEL_ERRORS_SET = 'at/panels/task/edit/TASK_PANEL_ERRORS_SET'
export const TASK_PANEL_ERRORS_REMOVE = 'at/panels/task/edit/TASK_PANEL_ERRORS_REMOVE'
export const TASK_PANEL_UPDATING_STATE_SET = 'at/panels/task/edit/TASK_PANEL_UPDATING_STATE_SET'
export const TASK_PANEL_SHOWN_SET = 'at/panels/task/edit/TASK_PANEL_SHOWN_SET'
export const TASK_PANEL_EDITABLE_SET = 'at/panels/task/edit/TASK_PANEL_EDITABLE_SET'
export const TASK_PANEL_OPENED_FROM_URL_SET = 'at/panels/task/edit/TASK_PANEL_OPENED_FROM_URL_SET'

export const TASK_PANEL_TAB_SET = 'at/panels/task/edit/TASK_PANEL_TAB_SET'
export const TASK_PANEL_LAST_TAB_SET = 'at/panels/task/edit/TASK_PANEL_LAST_TAB_SET'

export const ASSIGNED_USERS_SET = 'at/panels/task/edit/TASK_PANEL_ASSIGNED_USERS_SET'
export const CAN_MODIFY_ANY_MANAGER_SET = 'at/panels/task/edit/TASK_PANEL_CAN_MODIFY_ANY_MANAGER_SET'
export const CAN_MODIFY_ANY_USER_SET = 'at/panels/task/edit/TASK_PANEL_CAN_MODIFY_ANY_USER_SET'
export const ASSIGNED_MANAGERS_SET = 'at/panels/task/edit/TASK_PANEL_ASSIGNED_MANAGERS_SET'

export const TASK_DETAILS_SET = 'at/panels/task/edit/TASK_DETAILS_SET'

export const TASK_EXECUTORS_SUMMARY_SET = 'at/panels/task/edit/TASK_EXECUTORS_SUMMARY_SET'
export const ALL_TIME_COMMENTS_LOADED_SET = 'at/panels/task/edit/ALL_TIME_COMMENTS_LOADED_SET'
export const TIME_AND_COMMENTS_LOADING_SET = 'at/panels/task/edit/TIME_AND_COMMENTS_LOADING_SET'
export const REPORTED_TIME_COMMENTS_SET = 'at/panels/task/edit/REPORTED_TIME_COMMENTS_SET'
export const REPORTED_TIME_COMMENTS_ADD = 'at/panels/task/edit/REPORTED_TIME_COMMENTS_ADD'
export const SORTING_SETTINGS_SET = 'at/panels/task/edit/SORTING_SETTINGS_SET'

export const TASK_DELETED_SUCCESSFULLY_SET = 'at/panels/task/edit/TASK_DELETED_SUCCESSFULLY_SET'
export const TASK_DELETED_UNSUCCESSFULLY_SET = 'at/panels/task/edit/TASK_DELETED_UNSUCCESSFULLY_SET'
export const TASK_DELETION_STATUS_RESET = 'at/panels/task/edit/TASK_DELETION_STATUS_RESET'

export const TASK_AUDIT_HISTORY_INFO_SET = 'at/panels/task/edit/TASK_AUDIT_HISTORY_INFO_SET'
export const AUDIT_HISTORY_ADD = 'at/panels/task/edit/AUDIT_HISTORY_ADD'
export const AUDIT_HISTORY_SET = 'at/panels/task/edit/AUDIT_HISTORY_SET'

export const TASK_PANEL_STATE_RESET = 'at/panels/task/edit/TASK_PANEL_STATE_RESET'

export const NEW_COMMENTS_ADD = 'at/panels/task/edit/NEW_COMMENTS_ADD'
export const OLD_COMMENTS_ADD = 'at/panels/task/edit/OLD_COMMENTS_ADD'
export const COMMENTS_INFO_CLEAR = 'at/panels/task/edit/COMMENTS_INFO_CLEAR'
export const COMMENT_REMOVE = 'at/panels/task/edit/COMMENT_REMOVE'
export const CHANGE_COMMENTS_ORDER = 'at/panels/task/edit/CHANGE_COMMENTS_ORDER'
export const COMMENTS_LOADED_SET = 'at/panels/task/edit/COMMENTS_LOADED_SET'
export const COMMENTS_LOADING_SET = 'at/panels/task/edit/COMMENTS_LOADING_SET'
export const SENDING_COMMENT_SET = 'at/panels/task/edit/SENDING_COMMENT_SET'
export const RECENTLY_ADDED_COMMENTS_ADD = 'at/panels/task/edit/RECENTLY_ADDED_COMMENTS_ADD'
export const RECENTLY_ADDED_COMMENTS_REMOVE = 'at/panels/task/edit/RECENTLY_ADDED_COMMENTS_REMOVE'
export const COMMENTS_SCROLL_TO_SET = 'at/panels/task/edit/COMMENTS_SCROLL_TO_SET'
export const EDITING_COMMENT_ID_SET = 'at/panels/task/edit/EDITING_COMMENT_ID_SET'
export const EDITING_COMMENT_TEXT_SET = 'at/panels/task/edit/EDITING_COMMENT_TEXT_SET'
export const UPDATE_COMMENT = 'at/panels/task/edit/UPDATE_COMMENT'
export const UPDATING_COMMENT_ID_SET = 'at/panels/task/edit/UPDATING_COMMENT_ID_SET'
export const SHOW_NEW_COMMENT_INPUT_SET = 'at/panels/task/edit/SHOW_NEW_COMMENT_INPUT_SET'
export const NEW_COMMENT_SET = 'at/panels/task/edit/NEW_COMMENT_SET'
export const NEW_COMMENT_REMOVE = 'at/panels/task/edit/NEW_COMMENT_REMOVE'

export const NEED_INITIALIZE_FOCUS_SET = 'at/panels/task/edit/NEED_INITIALIZE_FOCUS_SET'



// WEBPACK FOOTER //
// ./web/js/panels/task/editPanel/actionTypes.js